// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#tagging-checkbox{margin-left:21px}#tagging-checkbox .checkbox-checkmark{background:transparent;border:1px solid #84d5ee;height:18px;width:18px}#tagging-checkbox .checkbox-checkmark:after{border-color:#84d5ee;height:4px;left:3px;top:3px;width:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
